import styled from 'styled-components'
import { SlideInModalLoader } from 'syf-component-library/ui/atoms'
import { fontSizes, spacing } from 'syf-component-library/defaultTheme'
import { SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal'

export const SlideInModalPortalWrapper = styled(SlideInModalPortal)<{
  isCloseInterstitialShown: boolean
}>`
  svg {
    box-sizing: unset;
  }
  h1 {
    font-size: ${fontSizes.root}px;
  }
  > div {
    overscroll-behavior: none;
  }
`

export const PaddedSlideInModalLoader = styled(SlideInModalLoader)`
  padding: ${spacing.large}px ${spacing.xxlarge}px;
`
